import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static emptyStringValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.trim() === '') {
      return { 'emptyString': true };
    }
    return null;
  }
}
